// Suivi local du « vu » pour les « nouveaux contacts » (#10), qui n'ont pas
// d'état serveur. Les suggestions de FUSION ne sont volontairement plus suivies
// ici : ce sont des actions (fusionner / écarter) résolues côté serveur
// (approve/decline), donc elles restent visibles tant que non traitées — un
// « vu » local les masquerait à tort. Les messages non lus ont leur propre
// accusé de lecture (messaging.markRead), hors sujet ici.
const CONTACTS_KEY = "notif:dismissedContacts";
// Réponses de fil (incr. 2) « vues » : pas d'état serveur de lecture par fil, on
// suit donc localement les ids de réponses écartées (comme les nouveaux contacts).
const THREADS_KEY = "notif:dismissedThreadReplies";

function readSet(key: string): Set<string> {
  try {
    const raw = localStorage.getItem(key);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

function addToSet(key: string, ids: string[]): void {
  if (ids.length === 0) return;
  const set = readSet(key);
  for (const id of ids) set.add(id);
  try {
    localStorage.setItem(key, JSON.stringify([...set]));
  } catch {
    /* quota/private mode : le « vu » ne persistera pas, sans casser l'UI */
  }
}

export function getDismissedContacts(): Set<string> {
  return readSet(CONTACTS_KEY);
}

export function dismissContacts(ids: string[]): void {
  addToSet(CONTACTS_KEY, ids);
}

export function getDismissedThreadReplies(): Set<string> {
  return readSet(THREADS_KEY);
}

export function dismissThreadReplies(ids: string[]): void {
  addToSet(THREADS_KEY, ids);
}
